import { styled } from "goober";
import { Icon } from "../Icon";
import { Tooltip } from "../Tooltip";
import { ControlButton } from "./ControlButton";

const IconButton = styled(ControlButton)`
  width: 24px;
  padding: 0;
  justify-content: center;
`;

export function RefreshButton({ onClick }: { onClick: () => void }) {
  return (
    <Tooltip content="Refresh">
      <IconButton type="button" onClick={onClick} aria-label="Refresh">
        <Icon name="refresh-cw" size={12} color="var(--text-secondary)" />
      </IconButton>
    </Tooltip>
  );
}
